import { useMutation, useQuery } from "@tanstack/react-query"
import axios from "axios"
import { checkForAuthorization } from "utilities/index"
import { RetryOnError, verifyToken } from "utilities/VerifyToken"

export const FetchAllApps = (startup_id) => {
    return useQuery(
        ['FetchAllApps-FetchAllApps-FetchAllApps-FetchAllApps-FetchAllApps-fetch-all', startup_id],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/assessments/get-all-apps/${startup_id}`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                }
            })
        }, {
        select: (data) => {
            return data?.data?.data || []
            // return data.data.data[0]?.config_values
            //     ?.map((item, index) => {
            //         return ({
            //             label: item?.name,
            //             value: item?.code
            //         })
            //     })
        },
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}